export function lineUnitCost(cost: unknown): number {
  const n = Number(cost);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function lineCostTotal(cost: unknown, quantity: number): number {
  return lineUnitCost(cost) * (Number(quantity) || 0);
}

export function computeCostSubtotalFromLines(
  products: Array<{ cost?: unknown; quantity: number }>
): number {
  return (products || []).reduce(
    (sum, p) => sum + lineCostTotal(p.cost, p.quantity),
    0
  );
}

export function resolveOrderProfitMetrics(input: {
  subtotal: number;
  costSubtotal?: number | null;
  grossProfit?: number | null;
  products: Array<{ cost?: unknown; quantity: number }>;
}): {
  costSubtotal: number;
  grossProfit: number;
  grossMarginPercent: number | null;
} {
  const computedCostSubtotal = computeCostSubtotalFromLines(input.products);
  const costSubtotal =
    input.costSubtotal != null && input.costSubtotal > 0
      ? input.costSubtotal
      : computedCostSubtotal;
  const grossProfit =
    input.grossProfit != null
      ? input.grossProfit
      : Math.max(0, input.subtotal - costSubtotal);
  const grossMarginPercent =
    input.subtotal > 0 ? (grossProfit / input.subtotal) * 100 : null;
  return { costSubtotal, grossProfit, grossMarginPercent };
}
